import { RootState } from '../../../../../../../../init-store';
import { selectParticipantRenderState } from '../../../../../../../shared/features/room-agent/dtmf/participant-list/selectors';
import { i18n } from '../../../../../../../shared/helpers/i18n';
import { FONT_FAMILY, TEXT_COLOR_PRIMARY } from '../constants';
import { Area, Coordinates, Drawer } from '../types';
import { SCALE } from './constants';

const TITLE_FONT_SIZE = Math.round(32 * SCALE);
const TITLE_FONT = `${TITLE_FONT_SIZE}px ${FONT_FAMILY}`;

export const TITLE_HEIGHT = Math.round(32 * SCALE);

export class TitleDrawer implements Drawer {
    private area: Area;
    private coordinates?: Coordinates;

    constructor(area: Area) {
        this.area = area;
    }

    draw(ctx: CanvasRenderingContext2D, state: RootState) {
        const { totalParticipants } = selectParticipantRenderState(state);
        const text = i18n('dtmf', 'participant-list.count', { count: totalParticipants });

        ctx.textBaseline = 'top';
        ctx.font = TITLE_FONT;
        ctx.fillStyle = TEXT_COLOR_PRIMARY;

        if (!this.coordinates) {
            const textMetrics = ctx.measureText(text);
            const x = Math.round(this.area.x + (this.area.width - textMetrics.width) / 2);
            const y = this.area.y;

            this.coordinates = { x, y };
        }

        ctx.fillText(text, this.coordinates.x, this.coordinates.y);
    }
}
